module.exports = __webpack_public_path__ + "static/media/interview31.cf973f6d.jpeg";